export const composeEllipsisAriaLabelText = "X7a";
export const encryptMenuText = "Y7a";
export const encryptDisableForwardingMenuText = "Z7a";
export const hideFrom = "_7a";
export const switchToHTMLMenuItem = "$7a";
export const composePostButtonLabel = "a8a";
export default {composeEllipsisAriaLabelText,encryptMenuText,encryptDisableForwardingMenuText,hideFrom,switchToHTMLMenuItem,composePostButtonLabel};